import * as t from "io-ts";

export const ScanType = t.type({
  id: t.string,
  slug: t.string,
  name: t.string,
  live: t.boolean,
});
